export enum DataTypeEnum {
    STRING = "STRING",
    NUMBER = "NUMBER",
    BOOLEAN = "BOOLEAN",
    JSON = "JSON",
    SYMBOL = "SYMBOL",
    BIGINT = "BIGINT",
    OPTION = "OPTION",
    DATE = "DATE",
}
